module.exports = __webpack_public_path__ + "img/gf.4904eaca.svg";